import React from 'react';
import { Box } from '@mui/material';
 import HotelAccordianCard from '../../../../modules/AllStarHotel/hotelAccordianCard';
import InvitationAccordianCard from '../../../../modules/Invitation/invitationAccordianCard';
import RegistrationAccordianCard from '../../../../modules/Registration/registrationAccordianCard';
import TransportationAccordianCard from '../../../../modules/Transportation/transportAccordianCard';
import TicketAccordianCard from '../../../../modules/Ticket/ticketAccordianCard';
import DraftHotelAccordianCard from '../../../../modules/DraftHotel/hotelAccordianCard';
import VipExperienceAccordianCard from '../../../../modules/VipExperience/vipAccordianCard';
import SatNightTransportAccordianCard from '../../../../modules/SatNightTransport/satNightTransportAccordianCard';
import AllStarTicketAccordianCard from '../../../../modules/AllStarTickets/ticketAccordianCard';
import AllStarRegistrationAccordianCard from '../../../../modules/AllStarRegistration/allStarRegistrationAccordianCard'

import DraftTransportationAccordianCard from '../../../../modules/Transportation/DraftTransportation/transportAccordianCard';

import DraftCombineTransportationAccordianCard from '../../../../modules/Transportation/DraftCombineTransportation/transportAccordianCard';
import PrivateTransportAccordianCard from '../../../../modules/PrivateVehicle/privateVehicleAccordianCard';
import CredentialAccordianCard from '../../../../modules/Credential/credentialAccordianCard';
import CombineFlightInfoAccordianCard from '../../../../modules/CombineFlightInfo/CombineFlightInfoAccordianCard';
import DraftFlightInfoAccordianCard from '../../../../modules/DraftFlightInfo/draftFlightInfoAccordianCard';
import DraftRegistrationAccordianCard from '../../../../modules/DraftRegistration/draftRegistrationAccordianCard';

const VirtusoAccordianCard = (props) => {
    const { classes, item, index} = props;
  
    return ( 
        <Box>
            {(() => {
                switch (props.moduleToShow) {
                    case 'Hotel':
                        return (
                            <HotelAccordianCard
                                classes={classes}
                                item={item}
                                index={index}
                                {...props}
                            />
                        );
                    case 'Player Hotel':
                    case 'PlayerHotel':
                        return (
                            <DraftHotelAccordianCard
                                classes={classes}
                                item={item}
                                index={index}
                                {...props}
                            />
                        );
                    case 'Invitation':
                        return (
                            <InvitationAccordianCard
                                classes={classes}
                                item={item}
                                index={index}
                                {...props}
                            />
                        );
                    case 'Registration':
                        return (
                            <RegistrationAccordianCard
                                classes={classes}
                                item={item}
                                index={index}
                                {...props}
                            />
                        );
                    case 'DraftRegistration':
                        return (
                            <DraftRegistrationAccordianCard
                                classes={classes}
                                item={item}
                                index={index}
                                {...props}
                            />
                        );
                    case 'All Star Registration':
                        return (
                            <AllStarRegistrationAccordianCard
                                classes={classes}
                                item={item}
                                index={index}
                                {...props}
                            />
                        );
                    case 'Transportation':
                    case 'Flight Info':
                        return (
                            <TransportationAccordianCard
                                classes={classes}
                                item={item}
                                index={index}
                                {...props}
                            />
                        );
                    case 'Ticket':
                        return (
                            <TicketAccordianCard
                                classes={classes}
                                item={item}
                                index={index}
                                {...props}
                            />
                        );
                    case 'VIP':
                        return (
                            <VipExperienceAccordianCard
                                classes={classes}
                                item={item}
                                index={index}
                                {...props}
                            />
                        );
                    case 'Saturday Night Transportation':
                        return (
                            <SatNightTransportAccordianCard
                                classes={classes}
                                item={item}
                                index={index}
                                {...props}
                            />
                        );
                    case 'All Star Ticket':
                        return (
                            <AllStarTicketAccordianCard
                                classes={classes}
                                item={item}
                                index={index}
                                {...props}
                            />
                        );
                    case 'Draft Transportation':
                        return (
                            <DraftTransportationAccordianCard
                                classes={classes}
                                item={item}
                                index={index}
                                {...props}
                            />
                        );
                    case 'Combine Transportation':
                        return (
                            <DraftCombineTransportationAccordianCard
                                classes={classes}
                                item={item}
                                index={index}
                                {...props}
                            />
                        );
                    case 'Private Transport':
                        return (
                            <PrivateTransportAccordianCard
                                classes={classes}
                                item={item}
                                index={index}
                                {...props}
                            />
                        );
                    case 'Credential':
                        return (
                            <CredentialAccordianCard
                                classes={classes}
                                item={item}
                                index={index}
                                {...props}
                            />
                        );
                    case 'Combine Flight Info':
                        if (!item.actualData.isfamilyMemberAttend) {
                            return (
                                (<CombineFlightInfoAccordianCard
                                    classes={classes}
                                    item={item}
                                    index={index}
                                    {...props}
                                />)
                            );
                        }else{
                            return(null)
                        }
                    case 'DraftFlightInfo':
                    case 'Draft Flight Info':
                        return (
                            (<DraftFlightInfoAccordianCard
                                classes={classes}
                                item={item}
                                index={index}
                                {...props}
                            />)
                        );

                    default:
                        return null;
                }
            })()}
        </Box> 
    );
};

export default VirtusoAccordianCard;
